import React, { CSSProperties } from 'react';
import styles from './AddPhotoControl.module.scss';

interface AddPassportPhotoControlProps {
  error: boolean;
  onClick: () => void;
}

export default (props: AddPassportPhotoControlProps) => {
  const { error, onClick } = props;
  const infoStyle: CSSProperties = error ? {color: 'red'} : {};

  return (
    <div className={styles.photo} onClick={onClick}>
      <div className={styles.wrapper}>
        <svg width="140" height="175" viewBox="0 0 156 205" fill="none" xmlns="http://www.w3.org/2000/svg">
          <mask id="mask0" mask-type="alpha" maskUnits="userSpaceOnUse" x="3" y="0" width="150" height="200">
            <rect x="3.5" y="0.5" width="149" height="199" rx="3.5" fill="white" stroke="#D4D4D4"/>
          </mask>
          <g mask="url(#mask0)">
            <ellipse cx="78" cy="183.5" rx="116" ry="83.5" fill="#C4C4C4"/>
            <ellipse cx="78" cy="55.5" rx="46.5" ry="55.5" fill="#C4C4C4"/>
            <g transform="translate(62, 150)">
              <path d="M22.7461 14.3477H35.4375V23.5234H22.7461V37.8672H13.0781V23.5234H0.351562V14.3477H13.0781V0.601562H22.7461V14.3477Z" fill="white"/>
            </g>
          </g>
        </svg>
        <span style={infoStyle}>verplicht!</span>
      </div>
    </div>
  );
}
